import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deletePais,
  getPaisById,
  postPais,
  updatePais,
} from "../../../../api/pais";
import Select from "react-select";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyPais() {
  return {
    name: "",
    localName: "",
    active: true,
    prefix: "",
    code: "",
  };
}

export default function EditPaisesPage() {
  const [pais, setPais] = useState(getEmptyPais());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const paisId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!paisId) {
      disableLoadingData();
      return;
    }
    getPaisById(paisId)
      .then((res) => {
        if (res.status === 200) {
          setPais(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la pais.",
        });
        history.push("/paises");
      });
  }, [paisId, disableLoadingData, history]);

  function savePais() {
    if (checkIsEmpty(pais.name))
      return alertError({
        error: null,
        customMessage: "El nombre es requerido.",
      });
    if (!paisId) {
      postPais(pais)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Pais creada correctamente.",
            });
            history.push("/paises");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guarda la pais.",
          });
        });
    } else {
      updatePais(paisId, pais)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Los cambios se han guardado correctamente.",
            });
            history.push("/paises");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }
  const handleChange = (element) => (event) => {
    if (element === "coin") {
      setPais({ ...pais, [element]: event._id });
    } else setPais({ ...pais, [element]: event.target.value });
  };

  const handleCheckboxChange = (seguro) => (event) => {
    const isChecked = event.target.checked;

    setPais((prev) => {
      const updatedAvailable = isChecked
        ? [...prev.available, seguro] // añadir si no está
        : prev.available.filter((item) => item !== seguro); // eliminar si está

      return {
        ...prev,
        available: updatedAvailable,
      };
    });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Editar pais"></CardHeader>
          <CardBody>
            <TextField
              id={`name`}
              label="Nombre internacional"
              value={pais.name}
              onChange={handleChange("name")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`localName`}
              label="Nombre local"
              value={pais.localName}
              onChange={handleChange("localName")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`prefix`}
              label="Prefijo"
              value={pais.prefix}
              onChange={handleChange("prefix")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`code`}
              label="Código ISO"
              value={pais.code}
              onChange={handleChange("code")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <Typography variant="h6" gutterBottom>
              Habilitar seguros
            </Typography>
            <div className="d-flex">
              <div className="col-md-2">
                {/* Caser */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pais.available.includes("caser")}
                      onChange={handleCheckboxChange("caser")}
                      name="checkCaser"
                    />
                  }
                  label="Caser"
                />
              </div>
              <div className="col-md-2">
                {/* Generali */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pais.available.includes("generali")}
                      onChange={handleCheckboxChange("generali")}
                      name="checkGenerali"
                    />
                  }
                  label="Generali"
                />
              </div>
              <div className="col-md-2">
                {/* Zurich */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pais.available.includes("zurich")}
                      onChange={handleCheckboxChange("zurich")}
                      name="checkZurich"
                    />
                  }
                  label="Zurich"
                />
              </div>
            </div>
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={pais.active}
                  onChange={() => setPais({ ...pais, active: !pais.active })}
                  name="checkActive"
                />
              }
              label="Activa"
            />
          </CardBody>
        </Card>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            onClick={() => history.push("/paises")}
            variant="outlined"
            style={{ marginRight: "20px" }}
          >
            Atrás
          </Button>
          <Button
            onClick={() => savePais()}
            variant="outlined"
            color="primary"
            style={{ marginRight: "20px" }}
          >
            Guardar pais
          </Button>
          {paisId && (
            <>
              <MuiThemeProvider theme={theme}>
                <Button
                  onClick={() => setOpenConfirmDialog(true)}
                  variant="outlined"
                  color="secondary"
                  style={{ marginRight: "20px" }}
                >
                  Eliminar pais
                </Button>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: "auto",
                  }}
                ></div>
              </MuiThemeProvider>

              <ConfirmDialog
                title={"¿Estás seguro de que quieres eliminar esta pais?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                  deletePais(paisId)
                    .then((res) => {
                      if (res.status === 204 || res.status === 200) {
                        alertSuccess({
                          title: "¡Eliminada!",
                          customMessage: "Pais eliminada correctamente",
                        });
                        history.push("/paises");
                      }
                    })
                    .catch((error) => {
                      alertError({
                        error: error,
                        customMessage: "No se ha podido eliminar la pais.",
                      });
                    });
                }}
              />
            </>
          )}
        </div>
      </>
    );
}
